export const types = {
    CONNECT: 'CONNECT',
    CREATEUSER: 'CREATE-USER',
    DISCONNECT: 'DISCONNECT',
    DISABLEUSER: 'DISABLE-USER',
    ENABLEUSER: 'ENABLE-USER',
    DELETEUSER: 'DELETE-USER',
    UPDATEUSER: 'UPDATE-USER',
    REMOVEUSERFROMGROUP: 'REMOVE-USER-FROM-GROUP',
    ADDUSERTOGROUP: 'ADD-USER-TO-GROUP',
    ADDGROUP: 'ADD-GROUP',
    MOVEUSER: 'MOVE-USER',
    UNLOCKUSER: 'UNLOCK-USER',
    LDAP: 'LDAP-QUERY',
    PASSWORD: 'PASSWORD-RESET'
};